import type { PlacementTab } from './PlacementAnalyticsService';

export type PlacementRoleBase = 'support' | 'management';

/** Super Admin listing — never `/alumni/placement-analytics`. */
export function listingPath(): string {
    return '/support/placement-analytics';
}

/** Institute shell path by role. */
export function instituteShellPath(
    roleBase: PlacementRoleBase,
    instituteId: number | string | null | undefined,
    tab?: PlacementTab
): string {
    const t = tab || (roleBase === 'support' ? 'data' : 'insights');
    if (roleBase === 'support') {
        if (instituteId == null || instituteId === '') return listingPath();
        return `/support/placement-analytics/${instituteId}/${t}`;
    }
    return `/management/placement-analytics/${t}`;
}

export function watchlistDashboardPath(roleBase: PlacementRoleBase, instituteId: number | string): string {
    return roleBase === 'support'
        ? `/support/watchlist-dashboard/${instituteId}`
        : `/management/watchlist-dashboard/${instituteId}`;
}

export function watchlistReportPath(instituteId: number | string): string {
    return `/support/watchlist-report?institute_id=${instituteId}`;
}

/**
 * Alumni Directory by company. A01 still pending — use query param stub
 * (`jobCompanyId`) so Task-29 can wire Directory filtering later.
 * Super Admin (support) must not deep-link into institute alumni directory.
 */
export function directoryByCompanyPath(companyId: number | string): string {
    return `/alumni/directory?jobCompanyId=${companyId}`;
}

/** Directory deep-links are institute-admin only. */
export function isDirectoryLinkEnabled(roleBase: PlacementRoleBase): boolean {
    return roleBase === 'management';
}

export const SUPPORT_TABS: { id: PlacementTab; label: string }[] = [
    { id: 'data', label: 'Placement Data' },
    { id: 'summary', label: 'Summary' },
    { id: 'insights', label: 'Insights' },
    { id: 'ahli', label: 'AHLI Matrix' },
    { id: 'spm', label: 'Salary Power Matrix' },
    { id: 'reconsideration', label: 'Reconsideration List' },
    { id: 'focus', label: 'Placement Focus' },
];

export const MANAGEMENT_TABS = SUPPORT_TABS.filter((t) => t.id !== 'data');
